import Vue from 'vue';

Vue.component('contact-map', {
    data() {
        return {
            map: null,
            sittardMarker: null,
        };
    },

    mounted() {
        this.init();
    },

    methods: {
        init() {
            EventBus.$once('google-maps-ready', this.initMap);
        },

        initMap() {
            const mapStyle = [
                {
                    featureType: 'all',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            weight: '2.00',
                        },
                    ],
                },
                {
                    featureType: 'all',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#9c9c9c',
                        },
                    ],
                },
                {
                    featureType: 'all',
                    elementType: 'labels.text',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                    ],
                },
                {
                    featureType: 'landscape',
                    elementType: 'all',
                    stylers: [
                        {
                            color: '#f2f2f2',
                        },
                    ],
                },
                {
                    featureType: 'landscape',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ],
                },
                {
                    featureType: 'landscape.man_made',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    elementType: 'all',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'all',
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: 45,
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#eeeeee',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#7b7b7b',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'labels.text.stroke',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'all',
                    stylers: [
                        {
                            visibility: 'simplified',
                        },
                    ],
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'transit',
                    elementType: 'all',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'water',
                    elementType: 'all',
                    stylers: [
                        {
                            color: '#a5c5d4',
                        },
                        {
                            visibility: 'on',
                        },
                    ],
                },
                {
                    featureType: 'water',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#a5c5d4',
                        },
                    ],
                },
                {
                    featureType: 'water',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#070707',
                        },
                    ],
                },
                {
                    featureType: 'water',
                    elementType: 'labels.text.stroke',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ],
                },
            ];

            const sittard = { lat: 51.004209377032325, lng: 5.844756727698837 };

            this.map = new google.maps.Map(
                document.getElementById('contact-map'),
                {
                    center: sittard,
                    zoom: 11,
                    styles: mapStyle,
                }
            );

            const image = 'media/images/marker.png';

            this.sittardMarker = new google.maps.Marker({
                position: sittard,
                map: this.map,
                icon: image,
            });
        },
    },
});
